//////////////////////////////////////////////////
// 規約同意チェックボックス
// 数量変更でカートフッターが差し替わっても動くよう、都度要素を取得する
//////////////////////////////////////////////////
function updateTermsSubmitState() {
  const submit = document.getElementById('checkout');
  const termsCheck = document.getElementById('termsCheck');
  if (!submit) return;
  submit.disabled = !termsCheck?.checked;
}

if (!window.__cmTermsCheckBound) {
  window.__cmTermsCheckBound = true;

  document.addEventListener('change', (event) => {
    if (event.target?.id === 'termsCheck') {
      updateTermsSubmitState();
    }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, updateTermsSubmitState);
  }
}

updateTermsSubmitState();
